"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _native = _interopRequireDefault(require("styled-components/native"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _transitionClass = _interopRequireDefault(require("../transitionClass"));

var _RadioGroup = require("./RadioGroup");

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-family: ", ";\n  margin-left: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n  color: ", ";\n\n  ", "\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  border-radius: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  opacity: 0;\n  width: ", ";\n  height: ", ";\n  padding: ", ";\n\n    ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  padding: 1px;\n  border-width: ", ";\n  border-color: ", ";\n  border-style: solid;\n  border-radius: ", ";\n  align-items: center;\n  justify-content: center;\n\n  \n  ", "\n\n    ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin: ", ";\n  flex-direction: row;\n  align-items: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-direction: column;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-direction: row;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var OutterContainer = _native.default.View(_templateObject());

var Container = _native.default.View(_templateObject2());

var Touchable = _native.default.TouchableWithoutFeedback(_templateObject3());

var InnerContainer = _native.default.View(_templateObject4(), function (props) {
  return props.muitheme.margin;
});

var RadioContainer = _native.default.View(_templateObject5(), function (props) {
  return props.muitheme.backgroundColor;
}, function (props) {
  return props.muitheme.containerBorderWidth;
}, function (props) {
  return props.muitheme.containerBorderColor;
}, function (props) {
  return props.muitheme.containerBorderRadius;
}, function (props) {
  return !props.value && props.muitheme.containerShadow && "\n    shadow-color: #000;\n    shadow-offset: {width: 0, height: 0};\n    shadow-opacity: 0.1;\n    shadow-radius: 8;\n  ";
}, function (props) {
  return props.value && props.muitheme.containerCheckedShadow && "\n    shadow-color: #000;\n    shadow-offset: {width: 0, height: 0};\n    shadow-opacity: 0.1;\n    shadow-radius: 8;\n  ";
}, function (props) {
  return props.value && "background-color: " + props.muitheme.backgroundCheckedColor + ";\n     border-width: " + props.muitheme.containerCheckedBorderWidth + ";\n     border-color: " + props.muitheme.containerCheckedBorderColor + ";\n    ";
}, function (props) {
  return props.disabled && "background-color: " + props.muitheme.backgroundDisabledColor + ";";
});

var CircleContainer = _native.default.Text(_templateObject6(), function (props) {
  return props.muitheme.circleSize;
}, function (props) {
  return props.muitheme.circleSize;
}, function (props) {
  return props.muitheme.circlePadding;
}, function (props) {
  return props.value && props.muitheme.circleCheckedShadow && "\n    shadow-color: #000;\n    shadow-offset: {width: 0, height: 0};\n    shadow-opacity: 0.1;\n    shadow-radius: 8;\n  ";
}, function (props) {
  return props.value && "opacity: 1;";
}, function (props) {
  return props.disabled && "color: " + props.muitheme.circleDisabledColor + ";";
});

var Circle = _native.default.View(_templateObject7(), function (props) {
  return props.muitheme.circleColor;
}, function (props) {
  return props.muitheme.containerBorderRadius;
});

var Label = _native.default.Text(_templateObject8(), function (props) {
  return props.muitheme.fontFamily;
}, function (props) {
  return props.muitheme.labelMargin;
}, function (props) {
  return props.muitheme.fontSize;
}, function (props) {
  return props.muitheme.fontWeight;
}, function (props) {
  return props.muitheme.fontStyle;
}, function (props) {
  return props.muitheme.labelColor;
}, function (props) {
  return props.value && "color: " + props.muitheme.labelCheckedColor + ";";
}, function (props) {
  return props.disabled && "color: " + props.muitheme.labelDisabledColor + ";";
});

var RadioComponent =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(RadioComponent, _Component);

  function RadioComponent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getRadioTheme", (0, _memoizeOne.default)(function (props) {
      return _this.context.getTheme(props);
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onPress", function () {
      _this.context.onChange(_this.props.value);
    });
    return _this;
  }

  var _proto = RadioComponent.prototype;

  _proto.render = function render() {
    var muitheme = this.getRadioTheme(this.props);
    var value = this.props.value === this.context.value;
    return _react.default.createElement(OutterContainer, null, _react.default.createElement(Container, null, _react.default.createElement(Touchable, {
      disabled: this.props.disabled,
      onPress: this.onPress
    }, _react.default.createElement(InnerContainer, {
      muitheme: muitheme
    }, _react.default.createElement(RadioContainer, {
      disabled: this.props.disabled,
      muitheme: muitheme,
      className: _transitionClass.default,
      value: value
    }, _react.default.createElement(CircleContainer, {
      disabled: this.props.disabled,
      muitheme: muitheme,
      className: _transitionClass.default,
      value: value
    }, _react.default.createElement(Circle, {
      muitheme: muitheme
    }))), (this.props.checkedLabel || this.props.label) && _react.default.createElement(Label, {
      disabled: this.props.disabled,
      muitheme: muitheme,
      className: _transitionClass.default,
      value: value
    }, value ? this.props.checkedLabel || this.props.label : this.props.label)))));
  };

  return RadioComponent;
}(_react.Component);

exports.default = RadioComponent;
(0, _defineProperty2.default)(RadioComponent, "contextType", _RadioGroup.RadioGroupContext);